import { Component, OnInit } from '@angular/core';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { MaestrasService } from 'src/app/service/maestras/maestras.service';
import { RespuestaComun } from 'src/app/modal/maestras/respuesta-comun';
import { AutorAdminListResponse } from 'src/app/modal/autor/autorAdminListResponse';
import { AutorService } from 'src/app/service/autor/autor.service';
import { DmlAutorComponent } from 'src/app/pagina-admin/dashboard/gestionLibros/mant-autor/dml-autor/dml-autor.component';

@Component({
  selector: 'app-mant-autor',
  templateUrl: './mant-autor.component.html',
  styleUrls: ['./mant-autor.component.scss']
})
export class MantAutorComponent implements OnInit {

  constructor(private autorService:AutorService,
    private utilitarioService: UtilitarioService,
    private maestrasService: MaestrasService,
    private modalService: MDBModalService,
    ) { }

  txtdescripcion:String = "";
  cboEstado:String = "";
  modalRefAnioDml: MDBModalRef;
  listEstado:RespuestaComun = new RespuestaComun();
  headElements = ['Autor','Fecha Creado', 'Estado','Editar'];
  listAutor:AutorAdminListResponse = new AutorAdminListResponse();
  
  page = 1;
  pageSize = 9;

  ngOnInit(): void {
    this.cargarDatoInicial();
    this.onBuscar();
  }

  onBuscar(){
    this.utilitarioService.loading = true;
    this.autorService.obtenerAdminList(this.txtdescripcion.toString(), this.cboEstado.toString()).subscribe(data=>{
      this.listAutor = data;
      // console.log(data);
      this.utilitarioService.loading = false;
    })
  }

  onNuevo(id:String){
    this.modalRefAnioDml = this.modalService.show(DmlAutorComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          id: id,
          x_titulo:'Nuevo Autor',
          x_proceso:'I',
        }
      }
    );
  }

  onEditar(id:String){
    this.modalRefAnioDml = this.modalService.show(DmlAutorComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          id: id,
          x_titulo:'Editar Autor',
          x_proceso:'U',
        }
      }
    );
  }

  cargarDatoInicial(){

    this.utilitarioService.loading = true;
    this.listEstado = new RespuestaComun();
    this.maestrasService.obtenerMaestra("TIPO_STATUS_TABLA").subscribe(data=>{
      this.listEstado = data;      
      this.utilitarioService.loading = false;
    });

  }

}
